import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        identity: null,
        dialogFormVisible: false,
        TeacherFormDiaog:false,
        StudentFormDiaog:false,//学生增加窗口
        works_status: null,
        name: null,
        delete:false,
        currentXueQi: '', // 存储学期值（根状态）
       
    },
      getters: {
    // 方便其他组件获取学期值
    getCurrentXueQi: (state) => state.currentXueQi
                  
         },
    modules: {
        page: {
            namespaced: true,
            state: {
                CurrentPage: 'home',
            },
            mutations: {
                setPage(state, pageName) {
                    state.CurrentPage = pageName;
                },
               
                
            },
          
        }

    },
    mutations: {

          // 用于修改学期值的方法
    // 用于修改学期值的方法
       setXueQi(state, xueQi) {
                  state.currentXueQi = xueQi;
                   },
                   
        setIdentity(state, identity) {
            state.identity = identity;
        },
        setDialogFormVisible(state, visible) {
            state.dialogFormVisible = visible;
        },
        setWorksStatus(state, status) {
            state.works_status = status;
        },
        setTeachers(state, teachers) {
            state.teachers = teachers;
        },
        setRekey(state, key) {
            state.rekey = key;
        },
        setname(state, name) {
            // 先清空再赋值，强制状态变化
            state.name = name; 
        },
        setTeacherFormDiaog(state,TeacherFormDiaog){
            state.TeacherFormDiaog=TeacherFormDiaog
        }
        ,
        //////
        setStudentFormDiaog(state,StudentFormDiaog){
            state.StudentFormDiaog=StudentFormDiaog
        },
        // 新增：重置搜索框内容
        resetName(state) {
        state.name = ''; // 清空搜索框
        },
        
    },
});
